// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Vessel icon.
 * @param {IconProps} props - The IconProps for the VesselIcon component.
 * @returns {ReactElement} The VesselIcon component.
 */

export const VesselIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='36' height='34' viewBox='0 0 36 34' fill='none' color={color} {...rest}>
      <path d='M18.0078 1V8.17002' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M7.64027 30.3865C3.16122 27.4253 3.91296 19.9096 3.91296 19.9096L18.0078 13.912V21.6232'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.0078 13.912L32.1027 19.9096C32.1027 19.9096 32.6665 25.6216 29.8475 29.0487'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.59351 18.3313V9.35752C7.59351 7.67399 9.01866 6.29109 10.7883 6.29109H25.2591C27.0131 6.29109 28.4539 7.65896 28.4539 9.35752V18.166'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.00024 28.7632C2.61333 31.9498 6.68518 33.1223 10.4438 30.8976C11.3835 30.3415 12.3545 29.0487 14.3121 29.0938C16.1601 29.1389 16.5046 30.2062 18.149 30.9878C19.8874 31.8145 22.0173 31.8446 23.7713 31.063C24.6953 30.6571 25.5097 30.0408 26.418 29.6199C29.3466 28.2821 33.2306 29.3344 35.0002 31.9649'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Icon>
  );
};
